import React from 'react';

interface Props {
  color?: string;
  size?: number;
}

/**
 * Location2 component
 * Renders the Location2 SVG icon with dynamic color and size.
 *
 * @param color - The color for the SVG icon
 * @param size - The size for the SVG icon
 * @returns The Location2 SVG icon element
 */
const LocationSVG: React.FC<Props> = ({ color = '#727272', size = 50 }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    enableBackground='new 0 0 24 24'
    viewBox='0 0 24 24'
    height={size}
  >
    <path
      fill={color}
      d='M12,2c-4.4,0-8,3.6-8,8c0,4.4,8,12,8,12s8-7.6,8-12C20,5.6,16.4,2,12,2z M12,12.6c-1.4,0-2.6-1.2-2.6-2.6  c0-1.4,1.2-2.6,2.6-2.6c1.4,0,2.6,1.2,2.6,2.6C14.6,11.4,13.4,12.6,12,12.6z'
    />
  </svg>
);

export default LocationSVG;
